var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateOfBirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 14C1.97333 13.24 2.87667 12.65 3.91 12.23C4.94333 11.81 6.04 11.6 7.2 11.6C8.36 11.6 9.45333 11.81 10.48 12.23C11.5067 12.65 12.4133 13.24 13.2 14V2.4H1.2V14ZM7.2 9.72C6.44 9.72 5.79667 9.45667 5.27 8.93C4.74333 8.40333 4.48 7.76 4.48 7C4.48 6.24 4.74333 5.59667 5.27 5.07C5.79667 4.54333 6.44 4.28 7.2 4.28C7.96 4.28 8.60333 4.54333 9.13 5.07C9.65667 5.59667 9.92 6.24 9.92 7C9.92 7.76 9.65667 8.40333 9.13 8.93C8.60333 9.45667 7.96 9.72 7.2 9.72ZM1.2 16C0.88 16 0.6 15.88 0.36 15.64C0.12 15.4 0 15.12 0 14.8V2.4C0 2.08 0.12 1.8 0.36 1.56C0.6 1.32 0.88 1.2 1.2 1.2H2.5V0.64C2.5 0.466667 2.56333 0.316667 2.69 0.19C2.81667 0.0633333 2.96667 0 3.14 0C3.32667 0 3.48333 0.0633333 3.61 0.19C3.73667 0.316667 3.8 0.466667 3.8 0.64V1.2H10.6V0.64C10.6 0.466667 10.6633 0.316667 10.79 0.19C10.9167 0.0633333 11.0667 0 11.24 0C11.4267 0 11.5833 0.0633333 11.71 0.19C11.8367 0.316667 11.9 0.466667 11.9 0.64V1.2H13.2C13.52 1.2 13.8 1.32 14.04 1.56C14.28 1.8 14.4 2.08 14.4 2.4V14.8C14.4 15.12 14.28 15.4 14.04 15.64C13.8 15.88 13.52 16 13.2 16H1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateOfBirth);
export default __webpack_public_path__ + "static/media/date-of-birth.035ba0827b422132f7c0ef8ccd74fffa.svg";
export { ForwardRef as ReactComponent };